<template>
  <v-container id="subscriptions-table">
    <v-col class="text-end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="add_click()"
            v-on="on"
            color="white"
            class="primary"
            elevation="1"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("button.additional_subscription") }}</span>
      </v-tooltip>
    </v-col>
    <MaterialCard
      elevation="0"
      color="primary"
      :title="$t('title.subscriptions')"
    >
      <base-datatable
        ref="subscriptionsDatatable"
        :header_items="headers"
        :type="$t('title.subscriptions')"
        dispatch_get="subscription/subscriptions"
        :edit_dialog="subscriptionEditForm"
        id_field="uuid"
        :delete_popup_text="{
          title: $t('table.you_are_about_to_cancel_subscription'),
          delete_button_text: $t('button.cancel_subscription')
        }"
        :custom_delete_dialog="subscriptionCancelForm"
        :hide_actions="hide_actions"
      >
      </base-datatable>
    </MaterialCard>
    <v-dialog v-model="show_create_dialog" max-width="800px" persistent>
      <v-card v-if="is_max_subscriptions_reached">
        <v-card-text class="text-center pa-6">
          {{
            $t("subscription.max_number_reached", {
              max_number_of_subscriptions: max_subscriptions,
              organization_name: $store.state.config.name
            })
          }}
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="show_create_dialog = false">
            {{ $t("button.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <CreateSubscription
        v-else
        @submit="onCreateSubmit"
        @cancel="show_create_dialog = false"
      />
    </v-dialog>
    <v-dialog v-model="show_no_mandate_dialog" max-width="800px" persistent>
      <v-card v-if="is_max_subscriptions_reached">
        <v-card-text class="text-center pa-6">
          {{
            $t("subscription.max_number_reached", {
              max_number_of_subscriptions: max_subscriptions,
              organization_name: $store.state.config.name
            })
          }}
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="show_no_mandate_dialog = false">
            {{ $t("button.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <MandateAlreadyRegisteredDialog
        v-else
        @cancel="show_no_mandate_dialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";
import { subscription_table } from "@/mixins/subscription";
import BaseDatatable from "@/components/views/BaseDatatable";
import CreateSubscription from "./Create.vue";
import MandateAlreadyRegisteredDialog from "./MandateAlreadyRegisteredDialog.vue";
import SubscriptionEditForm from "./Edit.vue";
import SubscriptionCancelForm from "./Cancel.vue";
import Vue from "vue";

export default {
  name: "Subscriptions",
  components: {
    BaseDatatable,
    MaterialCard,
    CreateSubscription,
    MandateAlreadyRegisteredDialog
  },
  mixins: [subscription_table],
  mounted() {
    this.fetchSubscriptionCount();
  },
  methods: {
    fetchSubscriptionCount() {
      this.$store
        .dispatch("subscription/subscriptions", "?limit=1&offset=0")
        .then(response => {
          this.subscription_count = response.data.total_items || 0;
        });
    },
    onCreateSubmit() {
      this.show_create_dialog = false;
      this.$refs.subscriptionsDatatable.getData();
      this.fetchSubscriptionCount();
    },
    add_click() {
      if (this.$store.getters["user/hasActiveMandate"]) {
        this.show_create_dialog = true;
      } else {
        this.$store
          .dispatch("user/user")
          .then(response => {
            this.$store.commit("user/user", response.data);
            if (response.data.active_mandate) {
              this.show_create_dialog = true;
            } else {
              this.show_no_mandate_dialog = true;
            }
          })
          .catch(() => {
            this.$store.commit("viewstate/notify", {
              text: this.$t("error.something_went_wrong"),
              color: "error"
            });
          });
      }
    },
    hide_actions(item) {
      if (!item.subscription_end_date) {
        return false;
      }
      const subscription_end_date = Vue.filter("parse_date")(
        item.subscription_end_date
      );
      if (!subscription_end_date) {
        return false;
      }
      subscription_end_date.setHours(0, 0, 0, 0);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return subscription_end_date <= now;
    }
  },
  data() {
    return {
      subscriptionEditForm: SubscriptionEditForm,
      subscriptionCancelForm: SubscriptionCancelForm,
      show_create_dialog: false,
      show_no_mandate_dialog: false,
      subscription_count: 0
    };
  },
  computed: {
    max_subscriptions() {
      return this.$store.state.user.max_number_of_subscriptions;
    },
    is_max_subscriptions_reached() {
      const max = this.max_subscriptions;
      if (max === null || max === undefined) return false;
      return this.subscription_count >= max;
    }
  }
};
</script>
